import React from "react";
import { Typography } from "@mui/material";
import Select from "@components/Select/Select";
import { useTranslation } from "react-i18next";
import { DRYBULK_CARGO_OPS_LANG_BASE } from "../constants";

const L = `${DRYBULK_CARGO_OPS_LANG_BASE}.detail.messages`;

interface ThreadPickerProps {
  isShipper: boolean;
  shipperCodes: string[];
  value: string | undefined;
  onChange: (threadKey: string) => void;
}

const ThreadPicker: React.FC<ThreadPickerProps> = ({
  isShipper,
  shipperCodes,
  value,
  onChange,
}) => {
  const { t } = useTranslation();

  if (isShipper) {
    return (
      <Typography variant="subtitle2" data-testid="drybulk-messages-thread-header">
        {t(`${L}.shipper-thread-header`)}
      </Typography>
    );
  }

  return (
    <div className="flex items-center gap-3" data-testid="drybulk-messages-thread-picker">
      <Typography variant="subtitle2" component="label">
        {t(`${L}.thread-label`)}
      </Typography>
      <Select
        testId="drybulk-messages-thread"
        value={value}
        options={shipperCodes.map((code) => ({ value: code, label: code }))}
        onChange={onChange}
      />
    </div>
  );
};

export default ThreadPicker;
